export const GA_CSR_TRACKING_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_CSR_DASHBOARD


// Track page views
export const pageViewCSRDashboard = (url: string, userBpId?: string, label?: string, pathName?: string): void => {
    window.gtag('config', GA_CSR_TRACKING_ID, {
        event: `${label}_page_view`,
        event_type: "page_view",
        event_page_path_name: pathName,
        page_path: url,
        ...(userBpId && { user__bp_id: userBpId }), // Include user_id if available
    });
};

// Track custom events
export const event = ({
                          action,
                          category,
                          label,
                          value,
                          event_tag,
                          event_type,
                          page_path
                      }: {
    action: string;
    category: string;
    label: string;
    value: number;
    event_tag?: string;
    event_type?: string;
    page_path?: string
}): void => {
    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
        event_tag: event_tag, // Event Tag
        event_type: event_type,     // Custom event type definition
        page_path: page_path ? page_path : window.location.pathname,
    });
};
